import { store } from "redux/store";

export const getJwtToken = () => {
  const state: any = store.getState();
  const { token, refreshToken , currentServerTime,expires} = state.Auth;
  return {token ,refreshToken, currentServerTime,expires}
};
